const initialState = {
    reconConfigurations: [],
    reconSourceFieldMappings: [],
    reconSourceFieldMappingsCopy: [],
    reconConfig: {
        reconName: '',
        referenceId: '',
        reconDesc: '',
        mc_on_matches: '',
        manual_net_limit: '',
        active: '',
        deletedIndex: '',
    },
    reconNames: [],
    reconNamesForSideBar: [],
    reconSummaryTypes: [],
    gridReconConfigurations: {
        fielddata: [
            {
                header: 'Recon Id',
                inputfield: false,
                length: 10,
                name: 'ref_id',
                placeholder: 'e.g. REF2020121212 ',
            },
            {
                header: 'Recon Name',
                inputfield: true,
                length: 10,
                name: 'recon_name',
                placeholder: '',
            },
            {
                header: 'Description',
                inputfield: true,
                length: 10,
                name: 'recon_desc',
                placeholder: '',
            },
            {
                header: 'Maker Checker on Matches',
                inputfield: true,
                length: 10,
                name: 'mc_on_matches',
                placeholder: '',
            },
            {
                header: 'Manual Net Limit',
                inputfield: true,
                length: 10,
                name: 'manual_net_limit',
                placeholder: '',
            },
            {
                header: 'Active',
                inputfield: false,
                length: 1,
                name: 'active',
                placeholder: 'e.g. Y/N',
            },
            {
                header: 'Created date',
                inputfield: false,
                length: 1,
                name: 'created_date',
                placeholder: 'e.g Integer',
            },
        ],
        instances: [],
    },
    reconSourceMappings: [],
    reconSourceNameMappings: [],
    reconSourceFilters: [],
    reconSourceMatchingType: null,
    reconFieldConfigurations: {
        mappedDataDictionary: [],
        unMappedDataDictionary: [],
        reconFieldMappings: [],
    },
    calculationFilterFormProps: {},
    isShowModal: false,
    isAutoMap: false,
    reconSourceSQLExpression: [],
    reconSourceFieldAggregationMappings: [],
    reconSourceNameMappingsForSelectionBox: [],
    reconSourceFieldsMappingsForLookup: [],
    reconFieldSettings: [],
    manualTriggerEvents: [],
    allSharedUsers: [],
    allLinkedSrcRecs: [],
};

export default initialState;
